export const propagateTraceHeaderCorsUrls = (config) => {
    var _a;
    const { traceParentInHeader } = config;
    const propagateCorsUrls = (_a = traceParentInHeader === null || traceParentInHeader === void 0 ? void 0 : traceParentInHeader.options) === null || _a === void 0 ? void 0 : _a.propagateTraceHeaderCorsUrls;
    if ((traceParentInHeader === null || traceParentInHeader === void 0 ? void 0 : traceParentInHeader.enabled) && propagateCorsUrls) {
        config.propagateTraceHeaderCorsUrls = propagateCorsUrls;
    }
};
//# sourceMappingURL=CoralogixPropgator.js.map